export default __webpack_public_path__ + "static/media/messagesImg.0aef4321.svg";